import type { ReactNode } from 'react';
import styles from './EntityChip.module.css';

export type EntityChipTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger';

export interface EntityChipProps {
  tone?: EntityChipTone;
  title?: string;
  children: ReactNode;
}

/** Small rounded label shown inline after an entity page title. */
export function EntityChip({ tone = 'neutral', title, children }: EntityChipProps) {
  return (
    <span className={`${styles.chip} ${styles[tone]}`} title={title}>
      {children}
    </span>
  );
}
